let audioContext: AudioContext | null = null;
let analyser: AnalyserNode | null = null;
let dataArray: Uint8Array;
let source: MediaStreamAudioSourceNode;
let animationId: number;


/**
 * @description start the voice animation by showing frequency modulation 
 * @param waveContainer the root div for the inner wavelets
 * @param waves wavelets div
 */
async function startVoiceWaveAnimation(stream:MediaStream,waveContainer:HTMLDivElement,waves:Array<HTMLDivElement>): Promise<void> {
  try {
    audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    analyser = audioContext.createAnalyser();
    source = audioContext.createMediaStreamSource(stream);
    analyser.fftSize = 64;

    const bufferLength: number = analyser.frequencyBinCount;
    dataArray = new Uint8Array(bufferLength);
    source.connect(analyser);
    if (waveContainer) waveContainer.classList.remove('hidden');

    animateWaves(waves);
  } catch (error) {
    console.error('Microphone access error:', error);
  }
}


/**
 * @description animate the wave by frequency
 * @param waves the wavelets div reference
 * 
 */
function animateWaves(waves:Array<HTMLDivElement>): void {
 
  const loop=()=>{ 
    if (!analyser) return;
    analyser.getByteFrequencyData(dataArray);

    waves.forEach((wave, i) => {
        const value = dataArray[i % dataArray.length];
        const height = Math.max(1, Math.min(30, value / 3));

        wave.style.height = `${height}px`;
    });

    animationId = requestAnimationFrame(loop);
  }

  loop()
}


/**
 * @description stop the animation
 */
function stopVoiceWaveAnimation(): void {
  if (animationId) cancelAnimationFrame(animationId);
  if (audioContext) audioContext.close();
  const waveContainer = document.querySelector<HTMLDivElement>('.voice-waves');
  if (waveContainer) waveContainer.classList.add('hidden');
}

export {startVoiceWaveAnimation,animateWaves,stopVoiceWaveAnimation}